import { Box, Radio, Text } from "@mantine/core";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

type DoughnutChartData = {
  label: string;
  value: number;
  detail: number;
  color: string;
};

type DoughnutChartProps = {
  title: string; // tieu de (text) trong chart
  data: DoughnutChartData[];
  size?: number; // Kích thước tổng thể
  thickness?: number; // Độ dày vòng
};

const DoughnutChart = ({
  title,
  data,
  size = 200,
  thickness = 40,
}: DoughnutChartProps) => {
  const { t } = useTranslation();
  const [hovered, setHovered] = useState<string | null>(null);
  const total = data.reduce((sum, item) => sum + item.detail, 0);

  const outerR = size / 2 - 10;
  const innerR = outerR - thickness;
  const center = size / 2;

  const polarToCartesian = (
    cx: number,
    cy: number,
    radius: number,
    angle: number
  ) => {
    const rad = (angle - 90) * (Math.PI / 180);
    return {
      x: cx + radius * Math.cos(rad),
      y: cy + radius * Math.sin(rad),
    };
  };

  const getPath = (
    cx: number,
    cy: number,
    startAngle: number,
    endAngle: number
  ) => {
    const startOuter = polarToCartesian(cx, cy, outerR, startAngle);
    const endOuter = polarToCartesian(cx, cy, outerR, endAngle);
    const startInner = polarToCartesian(cx, cy, innerR, endAngle);
    const endInner = polarToCartesian(cx, cy, innerR, startAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

    return `
      M ${startOuter.x} ${startOuter.y}
      A ${outerR} ${outerR} 0 ${largeArcFlag} 1 ${endOuter.x} ${endOuter.y}
      L ${startInner.x} ${startInner.y}
      A ${innerR} ${innerR} 0 ${largeArcFlag} 0 ${endInner.x} ${endInner.y}
      Z
    `;
  };

  let startAngle = 0;

  return (
    <Box
      style={{
        width: "455px",
        height: "308px",
        gap: "8px",
        borderRadius: "8px",
        paddingTop: "20px",
        paddingBottom: "20px",
      }}
    >
      <div className="relative flex flex-col items-center">
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          {data.map((item) => {
            const endAngle = startAngle + (item.detail / total) * 360;
            const path = getPath(center, center, startAngle, endAngle);
            startAngle = endAngle;

            return (
              <path
                key={item.label}
                d={path}
                fill={item.color}
                stroke="#fff"
                strokeWidth="0"
                onMouseEnter={() => setHovered(item.label)}
                onMouseLeave={() => setHovered(null)}
                className="cursor-pointer transition-opacity duration-300 hover:opacity-80"
              />
            );
          })}
        </svg>
        <div className="absolute top-[38%] text-center font-bold">
          <div className="text-[#5E656B]">{title}</div>
          <div className="text-[#2A81D0] text-[28px]">
            {total > 0 && data[0]
              ? `${Math.round((data[0].detail / total) * 100)}%`
              : "0%"}
          </div>
        </div>
        {/* 
      {hovered && (
        <div className="absolute bottom-12 px-3 py-1 bg-gray-800 text-white text-sm rounded-md shadow-lg">
          {hovered}
        </div>
      )} */}
      </div>
      {data.map((item: DoughnutChartData) => (
        <div className="flex justify-between border-b border-dashed border-[#D8DDE2] last:border-b-0 p-2">
          <div className="flex items-center gap-[10px]">
            <Radio
              checked
              sx={{
                "& .mantine-Radio-radio": {
                  background: `${item.color} !important`,
                  borderColor: `${item.color} !important`,
                },
              }}
            />
            {item.label}
          </div>
          <Text weight={700}>{item.value}</Text>
        </div>
      ))}
    </Box>
  );
};

export default DoughnutChart;
